jQuery(function($){
  var $video = $('#auto-video');
  if ($video.length) {
    webshim.polyfill('mediaelement');
  }
});
